import { useState } from "react";
import { Mail, Phone } from "lucide-react";
import "./Contact.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Replace this with your form service or backend endpoint
    fetch("https://formspree.io/f/mblgpgbv", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(() => {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      })
      .catch(() => alert("There was a problem submitting the form."));
  };

  return (
    <div className="contact-page">
      <h1>Get in Touch</h1>
      <p>
        Have questions about ChipServer? We're here to help. Reach out to our
        team for support or inquiries.
      </p>

      <div className="contact-grid">
        {/* Left Side - Contact Info */}
        <div className="contact-info">
          <h3>Contact Information</h3>

          <div className="info-box">
            <Mail className="icon" />
            <div>
              <strong>Email Us</strong>
              <p>info@thechipserver.com</p>
            </div>
          </div>

          <div className="info-box">
            <Phone className="icon" />
            <div>
              <strong>Call Us</strong>
              <p>+1 (347) 560-0705</p>
            </div>
          </div>
        </div>

        {/* Right Side - Contact Form */}
        <div className="contact-form">
          <h3>Send us a Message</h3>
          <form onSubmit={handleSubmit}>
            <label>
              Name
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder="Your name"
              />
            </label>

            <label>
              Email
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                placeholder="Your email"
              />
            </label>

            <label>
              Message
              <textarea
                name="message"
                required
                value={formData.message}
                onChange={handleChange}
                placeholder="How can we help you?"
              ></textarea>
            </label>

            <button type="submit" className="btn-primary">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
